export default {
    "tagPicker_createNewTag": "Crear nueva etiqueta"
};